import { render, staticRenderFns } from "./SearchableTable.vue?vue&type=template&id=80ab644e"
import script from "./SearchableTable.vue?vue&type=script&lang=js"
export * from "./SearchableTable.vue?vue&type=script&lang=js"
import style0 from "./SearchableTable.vue?vue&type=style&index=0&id=80ab644e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports